module.exports = __webpack_public_path__ + "static/media/404.efb26ff7.svg";